module.exports = __webpack_public_path__ + "img/logo-em-line.e1464988.png";